import { ReactNode } from 'react';
import { Modal } from 'antd';
import './payease-modal.scss';

interface IPayEaseModalProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  subtitle?: ReactNode;
  width?: number;
  afterOpenChange?: (open: boolean) => void;
  children: ReactNode;
}

export const PayEaseModal = ({ open, onClose, title, subtitle, width = 460, afterOpenChange, children }: IPayEaseModalProps) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    width={width}
    centered
    getContainer={false}
    title={title}
    afterOpenChange={afterOpenChange}>
    {subtitle && <p className="pe-modal__subtitle">{subtitle}</p>}
    {children}
  </Modal>
);
